export const MEDICAL_DISCLAIMER_TEXT =
  "Bite Balance is not a substitute for professional medical advice, diagnosis, or treatment. Always consult a qualified healthcare professional for medical advice, diagnosis, or treatment.";

export const MEDICAL_DISCLAIMER_CHECKBOX_LABEL =
  "I understand this app is not a substitute for medical advice, diagnosis, or treatment.";

export const MEDICAL_DISCLAIMER_STORAGE_KEY =
  "bite_balance_health_disclaimer";

export const MEDICAL_DISCLAIMER_STATE_KEY = "medicalDisclaimerAtom";

export type MedicalDisclaimerState = {
  is_accept: boolean;
};

const DEFAULT_DISCLAIMER_STATE: MedicalDisclaimerState = { is_accept: false };

export function readMedicalDisclaimerState(): MedicalDisclaimerState {
  try {
    const raw = localStorage.getItem(MEDICAL_DISCLAIMER_STORAGE_KEY);
    if (!raw) {
      if (localStorage.getItem("bite_balance_health_disclaimer_accepted") === "true") {
        return { is_accept: true };
      }
      return DEFAULT_DISCLAIMER_STATE;
    }
    if (raw === "true") {
      return { is_accept: true };
    }
    const parsed = JSON.parse(raw) as { is_accept?: boolean };
    return { is_accept: parsed?.is_accept === true };
  } catch {
    return DEFAULT_DISCLAIMER_STATE;
  }
}

export function writeMedicalDisclaimerState(
  state: MedicalDisclaimerState,
): void {
  localStorage.setItem(MEDICAL_DISCLAIMER_STORAGE_KEY, JSON.stringify(state));
}

export function hasAcceptedMedicalDisclaimer(): boolean {
  return readMedicalDisclaimerState().is_accept === true;
}

export function acceptMedicalDisclaimer(): void {
  writeMedicalDisclaimerState({ is_accept: true });
}
